<script>
import {
  pageTitleMixin,
  prefetchDataMixin,
} from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import IconPlus from '@/components/icons/Plus';
import PluralText from '@/components/PluralText';
import OrgStructure from './components/OrgStructure';
import service from './service';

export default {
  pageTitle: 'Список департаментов',
  async prefetchData () {
    this.isFetching = true;

    this.list = await service.getList();

    this.isFetching = false;
  },
  mixins: [
    pageTitleMixin,
    prefetchDataMixin,
  ],
  data () {
    return {
      isFetching: false,
      list: [],
    };
  },
  computed: {
    hasReadPermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.DEPARTMENT_READ);
    },
    hasWritePermission () {
      return this.$store
        .getters['auth/checkPermission'](permissions.DEPARTMENT_WRITE);
    },
  },
  methods: {
    handleChildrenViewClose () {
      this.$_setTitle();
    },
    handleDataUpdate () {
      service.getList()
        .then(data => {
          this.list = data;
        });
    },
  },
  render () {
    if (!this.hasReadPermission) {
      return (
        <ErrorAccessDenied />
      );
    }

    if (this.isFetching) {
      return <u-spinner />;
    }

    const { $style, list } = this;

    return (
      <div>
        <u-title class="page-header">
          <span>
            Список департаментов
          </span>
          {this.hasWritePermission && (
            <router-link
              class="u-btn u-btn_outline u-btn_square u-btn_primary"
              to="/departments/create"
            >
              <IconPlus />
            </router-link>
          )}
        </u-title>

        <transition-group
          tag="div"
          class={$style.list}
        >
          {list.map(department => (
            <div
              key={department.id}
              class={$style.listItem}
            >
              <div
                class={$style.department}
                style={{ borderColor: department.color }}
              >
                <div class={$style.departmentName}>
                  <router-link to={`/departments/${department.id}`}>
                    {department.name}
                  </router-link>
                </div>

                <div class={$style.departmentWorkers}>
                  {department.workersCount}
                  <PluralText
                    value={department.workersCount}
                    single=" сотрудник"
                    few=" сотрудника"
                    many=" сотрудников"
                  />
                </div>
              </div>
            </div>
          ))}
        </transition-group>

        <OrgStructure />

        <router-view
          onClose={this.handleChildrenViewClose}
          onDataupdate={this.handleDataUpdate}
        />
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.list {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -.5em;

  &Item {
    overflow: hidden;
    padding: 0 .5em;
    width: 20%;

    &:global(.v-enter-active) {
      transition: opacity .2s, width .3s;
    }

    &:global(.v-leave-active) {
      position: absolute;
    }

    &:global(.v-enter),
    &:global(.v-leave-to) {
      opacity: 0;
      width: 0;
    }

    &:global(.v-move) {
      transition: transform .3s;
    }
  }
}

.department {
  background-color: $color-white;
  border: 1px solid transparent;
  border-left-width: 1em;
  border-radius: .25em;
  margin: 0 0 1em;
  padding: .5em;
  white-space: nowrap;

  &Workers {
    font-size: .825em;
  }
}
</style>
